import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Hero() {
  const { t } = useTranslation('apropos');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  const navigateTo = (path: string) => {
    if (window.REACT_APP_NAVIGATE) window.REACT_APP_NAVIGATE(path);
  };

  return (
    <section id="hero" className="relative min-h-[65vh] md:min-h-[70vh] flex items-center justify-center overflow-hidden pt-16">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Professional roofing crew team of 6 workers standing together in front of white company truck at residential construction site in Quebec suburb, wearing matching navy blue uniforms and safety helmets, smiling naturally at camera, autumn day with overcast sky, authentic documentary photography style, warm natural tones, no text visible, landscape composition"
          alt="Équipe de couvreurs partenaires Couvreur-Lévis.com devant camion entreprise — réseau RBQ à Lévis"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchpriority="high"
          width="1920"
          height="800"
          fetchpriority="high"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-primary/60 via-slate-primary/40 to-slate-primary/70" />
      </div>

      <div
        ref={ref}
        className={`relative z-10 w-full px-4 md:px-6 lg:px-10 max-w-4xl mx-auto text-center transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <nav className="mb-6" aria-label="Fil d'Ariane">
          <ol className="flex items-center justify-center gap-2 text-sm text-white/70">
            <li>
              <button onClick={() => navigateTo('/')} className="hover:text-white transition-colors">
                {t('breadcrumb_home')}
              </button>
            </li>
            <li><i className="ri-arrow-right-s-line" /></li>
            <li className="text-white font-medium">{t('breadcrumb_current')}</li>
          </ol>
        </nav>

        <h1 className="font-manrope font-extrabold text-white text-[40px] sm:text-4xl md:text-5xl lg:text-[56px] leading-tight mb-5">
          {t('hero_h1')}
        </h1>
        <p className="text-white/85 text-base md:text-lg lg:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          {t('hero_subtitle')}
        </p>
        <button
          onClick={() => navigateTo('/soumission-gratuite')}
          className="group bg-copper hover:bg-copper-dark text-white font-bold px-8 py-4 rounded-md text-base md:text-lg transition-all duration-300 flex items-center gap-3 mx-auto whitespace-nowrap"
        >
          {t('hero_cta')}
          <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
        </button>
      </div>
    </section>
  );
}